import { Stack, Typography, Box } from '@mui/material';
import { FC } from 'react';
import { Article } from '../../const/ARTICLES';

import Markdown from 'react-markdown';

const TitleTypography = ({ children }: { children: React.ReactNode }) => (
  <Typography
    sx={{
      fontWeight: 500,
      fontSize: {
        xs: '32px',
        sm: '56px',
        md: '60px',
      },
      lineHeight: '130%',
      letterSpacing: '-5%',
      textAlign: 'center',
      marginTop: {
        xs: '80px',
        sm: '80px',
        md: '120px',
      },
      marginBottom: {
        xs: '48px',
        sm: '48px',
        md: '88px',
      },
      color: '#38383B',
    }}
  >
    {children}
  </Typography>
);

const DetailTypography = ({ children }: { children: React.ReactNode }) => (
  <Typography
    component={'div'}
    sx={{
      fontFamily: 'Poppins',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: {
        xs: '14px',
        sm: '20px',
        md: '24px',
      },
      lineHeight: '130%',
      letterSpacing: '-2%',
      color: '#5F5F62',
    }}
  >
    {children}
  </Typography>
);

const BlogSection: FC<{ article: Article }> = ({ article }) => {
  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <Box
        component="img"
        src={article.image}
        sx={{
          height: {
            xs: '224px',
            sm: '224px',
            md: '560px',
          },
          width: { xs: '100%', sm: '100%' },
          cursor: 'pointer',
          display: 'block',
          objectFit: 'cover',
        }}
      />
      <Box
        sx={{
          margin: '0 auto',
          maxWidth: '1440px',
          padding: {
            xs: '0 24px 80px 24px',
            sm: '0 40px 120px 40px',
            md: '0 40px 260px 40px',
          },
        }}
      >
        <TitleTypography>{article.title}</TitleTypography>
        <Stack
          spacing={'120px'}
          sx={{
            marginBottom: {
              xs: '48px',
              sm: '80px',
              md: '120px',
            },
          }}
        >
          <DetailTypography>
            <Markdown>{article.description}</Markdown>
          </DetailTypography>
        </Stack>
      </Box>
    </Box>
  );
};

export default BlogSection;
